import React from 'react';
import cx from 'classnames';
import './ProgressBar.scss';

const ProgressBar = ({ progress, color, tier }) => {
  const style = {
    width: `${progress}%`,
    height: '100%',
    backgroundColor: color,
    transition: 'width .1s ease',
  };

  const starter = cx({ starter: tier === 'starter' });
  return (
    <div className={`progress-bar ${starter}`}>
      <div className="progress-bar-overlay" style={style} />
    </div>
  );
};

export default ProgressBar;
